module.exports = __webpack_public_path__ + "static/Vazir-e3e8c52a5a6a92c839fb985db61fa3ab.ttf";